import { render, staticRenderFns } from "./SingleDeleteDialog.vue?vue&type=template&id=6aeb2a73&"
import script from "./SingleDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./SingleDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports